export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-lg font-bold font-display">
                榴
              </span>
              <span className="text-lg font-bold text-background-50 font-heading">
                榴莲视频
              </span>
            </div>
            <p className="text-sm text-background-300 leading-relaxed">
              榴莲视频致力于为观众提供97视频、丝瓜视频、蓝莓视频、91在线视频、糖心视频、黑桃视频等热门在线视频平台的综合对比与导航服务，帮助用户快速找到最合适的在线影视平台。
            </p>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              快速导航
            </h3>
            <div className="grid grid-cols-2 gap-2">
              <a href="#index" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">热门专题</a>
              <a href="#carousel" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">焦点推荐</a>
              <a href="#ranking" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">热度榜单</a>
              <a href="#updates" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">最新动态</a>
              <a href="#faq" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">常见问答</a>
              <a href="#contact" className="text-sm text-background-300 hover:text-background-100 transition-colors whitespace-nowrap cursor-pointer">联系我们</a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold text-background-100 mb-4 font-heading">
              合作伙伴
            </h3>
            <p className="text-sm text-background-400 leading-relaxed">
              更多优质视频平台合作持续拓展中，敬请期待。
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-400">
            &copy; {new Date().getFullYear()} 榴莲视频 - 在线视频平台对比导航
          </p>
          <p className="text-xs text-background-500">
            本站仅提供平台信息对比，不存储任何视频内容
          </p>
        </div>
      </div>
    </footer>
  );
}